// eslint-disable-next-line no-unused-vars
import React from 'react';
import ContainerContentComponent from './container/containerContentComponent';
import ContainerTitleComponent from './container/containerTitleComponent';

const SectionContainer = ({title, children, withLoginContent = false}) => {
  return (
    <>
      {title && <ContainerTitleComponent title={title} />}
      <ContainerContentComponent withLoginContent={withLoginContent}>{children}</ContainerContentComponent>
    </>
  );
};

export default SectionContainer;
